<template>
  <el-table
    :data="$props.accounts"
    stripe
  >
    <el-table-column
      v-if="!!$scopedSlots['peek']"
      type="expand"
    >
      <template v-slot="{ row }">
        <slot
          name="peek"
          :account="row"
        />
      </template>
    </el-table-column>

    <el-table-column
      show-overflow-tooltip
      label="Account"
    >
      <template v-slot="{ row }">
        <RouterLink :to="{ name: 'sales-accounts-account', params: { accountId: row.id } }">
          {{ row.name }}
        </RouterLink>
      </template>
    </el-table-column>

    <el-table-column
      show-overflow-tooltip
      label="Portfolio"
      :formatter="row => $_.get(row, 'portfolio.long', '-')"
    />

    <el-table-column
      show-overflow-tooltip
      label="Billing Group"
      :formatter="row => $_.get(row, 'b_group.long', '-')"
    />

    <el-table-column
      label="Grade"
      align="center"
      :width="120"
    >
      <template v-slot="{ row }">
        <el-tag
          :type="getGradeTagType($_.get(row, 'crm_account_grade'))"
          size="mini"
        >
          {{ getGradeDescription($_.get(row, 'crm_account_grade')) }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column
      label="Status"
      align="center"
      :width="120"
    >
      <template v-slot="{ row }">
        <el-tag
          :type="getStatusTagType($_.get(row, 'status'))"
          size="mini"
        >
          {{ $_.get(row, 'status') | titleize }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="left"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :account="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import CRMAccountsTable from '@/components/Application/CustomerService/Accounts/Table'

export default {
  extends: CRMAccountsTable
}
</script>
